module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsSAAALEgHS3X78AAAAXElEQVRIiWNklLVqYGBgqGegEfj/+BgjC8hoZi5VMKY2+PVmG9hEJlr5ABmMWjJqyaglo5aMWoIDjFoyagntALgh8f/fd4b/v9/R1JIH/348OfDvxxPa2MDAwAAAOMIUZnHBuewAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-blue-1.png
// module id = 251
// module chunks = 0